import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams, useResolvedPath, useSearchParams } from "react-router-dom";
import { SERVER_URL, SIGNUP_VERIFICATION_API_PATH } from "../../../../../global_vars";
import luxoraLogo from "../../../../../assets/luxora.png";

interface SignupVerificationState {
    status: number;
    statusMsg: string;
}

function SignupVerification() {

    const currentYear: number = new Date().getFullYear();
    const { verificationCode } = useParams();

    const [state, setState] = useState<SignupVerificationState>({
        status: 0,
        statusMsg: "",
    });

    const verificationFlag = useRef(false);

    const handleResetStatusMsg = () => {
        setState({
            ...state,
            status: 0,
            statusMsg: "",    
        });
   }

    useEffect(() => {
        if(!verificationFlag.current){
            verificationFlag.current = true;
            handleResetStatusMsg();
            fetch(SERVER_URL+SIGNUP_VERIFICATION_API_PATH, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: verificationCode
                })
            }).then((resp) => {
                if (resp.status==200) {
                    console.log("Received: 200");
                    setState({
                        ...state,
                        status: 1,
                        statusMsg: "Email successfully verified. Please click on the sign in link to start using Luxora.",
                    })
                } else {
                    console.log("Received other than 200");
                    setState({
                        ...state,
                        status: -1,
                        statusMsg: `Registration Unsuccessful due to ${resp.status}`,
                    })
                }
            }).catch((error) => {
                console.log("Error while logging in: ", error);
                setState({
                    ...state,
                    status: -1,
                    statusMsg: "Unknown error while logging in. Contact Administrator",
                })
            });
        }
    });


    return(
        <div>
            <div className="bg-home bg-circle-gradiant d-flex align-items-center">
                <div className="bg-overlay bg-overlay-white"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center my-5">
                            <img src={luxoraLogo} alt="Luxora Logo" className="logo" />
                            </div>
                            <div className="card form-signin p-4 rounded shadow" >
                                <form method="POST" className="needs-validation" autoComplete="off">
                                    <h5 className="mb-3 text-center">Email Link Verification</h5>
                                    <div className="row">
                                        {
                                            state.status === -1 && state.statusMsg.length>0 &&
                                            <div className="alert alert-danger fade show" role="alert">
                                                <div>{state.statusMsg}</div>
                                            </div>
                                        }
                                    </div>

                                    <div className="row">
                                        {
                                            state.status === 1 &&
                                            <div className="alert alert-success fade show" role="alert">
                                                <div>{state.statusMsg}</div>
                                            </div>
                                        }
                                    </div>


                                    <div className="col-12 text-center mt-3">
                                        <p className="mb-0 mt-3"><small className="text-dark me-2">Already have a verified account ?</small> <a href="/login" className="text-dark fw-bold">Sign in</a></p>
                                    </div>

                                    <p className="mb-0 text-muted mt-3 text-center">© {currentYear} Luxora.</p>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}


export default SignupVerification;